/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_SuccessInputs */



/**
* | output |
* | --- |
* | "Metadata merged successfully" |
*
* @param {Metadata_Merge_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_success = /** @type {((inputs?: Metadata_Merge_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Métadonnées fusionnées avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten erfolgreich zusammengeführt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metadati uniti con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Метаданные успешно объединены.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los metadatos se fusionaron correctamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据合并成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータのマージに成功しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा सफलतापूर्वक मर्ज हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metadados mesclados com sucesso")
	return /** @type {LocalizedString} */ ("Metadata merged successfully")
});